import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import merge from 'lodash-es/merge';
import { getCommonType } from './store';
import { AuthProvider } from './context/AuthContext';
import { Provider } from 'react-redux';
import WebAppAuth from './web-app-auth';
import { TonicProvider, Box, theme } from '@tonic-ui/react';
import { useThemeColorStyle } from './hooks/use-theme-color-style';
import { customColorStyle } from './styles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
    },
  },
});

const Layout = (props) => {
  const colorStyle = useThemeColorStyle();
  return (
    <Box
      backgroundColor={colorStyle.background.secondary}
      color={colorStyle.color.primary}
      fontSize="sm"
      lineHeight="sm"
      height="100%"
      overflow="auto"
      tabIndex="-1"
      {...props}
    />
  );
};
const WebAppAuthBootstrap = (props) => {
  const {
    theme: { colorMode, overrides },
  } = useSelector(
    (state) => ({
      theme: getCommonType(state, 'theme'),
    }),
    shallowEqual
  );
  const customTheme = merge(theme, overrides);

  return (
    <TonicProvider
      theme={customTheme}
      colorMode={{ defaultValue: 'light', value: colorMode }}
      colorStyle={{
        defaultValue: customColorStyle,
      }}
    >
      <Layout>
        <QueryClientProvider client={queryClient}>
          <AuthProvider authProps={props}>
            <WebAppAuth {...props} />
          </AuthProvider>
        </QueryClientProvider>
      </Layout>
    </TonicProvider>
  );
};

const WebAppAuthContainer = (props) => {
  return (
    <Provider store={props.store}>
      <WebAppAuthBootstrap {...props} />
    </Provider>
  );
};

export default WebAppAuthContainer;
